import React from "react";
import { Button } from "react-bootstrap";

type BtnFloatingProps = {
  onClick: () => void;
  icon?: string; // FontAwesome class
  label?: string;
  children?: React.ReactNode;
};

export const BtnFloating: React.FC<BtnFloatingProps> = ({
  onClick,
  label = "Open dialog",
  children,
}) => {
  return (
    <Button
      onClick={onClick}
      aria-label={label}
      variant="outline-light"
      className="border-none bg-divelit-plum-70 position-fixed bottom-0 end-0 m-4 rounded-circle d-flex align-items-center justify-content-center shadow "
      style={{
        width: "72px",
        height: "72px",
        zIndex: 1050,
      }}
    >
      {children}
    </Button>
  );
};
